__turbopack_context__.v({
  "main": "HomeView-module__pGiYGa__main",
  "page": "HomeView-module__pGiYGa__page",
});
